module.exports = __webpack_public_path__ + "img/lock-icon.1b5744ba.svg";